module.exports = "https://cdn.dashboard.gifty.nl/5680/images/mailbox-white.png?e6f3f0852ddf5976b5b1797ee981d08c";